var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2061 3.63641C13.9461 3.37641 13.5261 3.37641 13.2661 3.63641L6.05515 10.8406L3.31469 8.1001C3.05469 7.8401 2.63469 7.8401 2.37469 8.1001C2.11469 8.3601 2.11469 8.78011 2.37469 9.04011L5.54089 12.2063C5.82491 12.4904 6.28539 12.4904 6.56941 12.2063L14.2061 4.56974C14.4594 4.31641 14.4594 3.88974 14.2061 3.63641Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLightIcon);
export default __webpack_public_path__ + "static/media/CheckLightIcon.d0c2753683cc13cda6b813bd03aba089.svg";
export { ForwardRef as ReactComponent };